var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0537 5.08957L9 16.6767L18 5.79326L13.0537 5.08957Z",
    fill: "#2FC0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 16.6767L13.7574 5.79326L8.29633 5.08957L9.00001 16.6767Z",
    fill: "#9EE2F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.6767L4.94627 5.08957L0 5.79326L9 16.6767Z",
    fill: "#9EE2F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.08957L4.24258 5.79326L9 16.6767V5.08957Z",
    fill: "#BDFDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 1.32327L12.6211 2.97235L13.7574 5.79325H18L13.7574 1.32327Z",
    fill: "#BDFDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 5.79325V1.32327H13.7574H9L10.793 4.2539L13.7574 5.79325H13.7574Z",
    fill: "#9EE2F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 5.79325L9 1.32327L8.19141 3.9961L9 5.79325H13.7574Z",
    fill: "#BDFDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24258 5.79321V5.79325H9V1.32327L6.03517 2.68357L4.24258 5.79321Z",
    fill: "#9EE2F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.32327H4.24259L3.33984 4.13672L4.24259 5.79321L9 1.32327Z",
    fill: "#BDFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24259 1.32327L0 5.79325H4.24259V1.32327Z",
    fill: "#2FC0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.91cee70be68ead7bb29723709188d0a4.svg";
export { ForwardRef as ReactComponent };